import axios from 'axios';
import Config from '../../commons/config/Config.js';
import swal from 'sweetalert2';
import backendStrings from '../../lang/backendStrings.js';
import { MODAL_RESET_TIMEOUT_MS } from '../constants/modal.js';
// import { useIntl, FormattedMessage } from 'react-intl'

const isPermissionDeniedError = (err) => {
  const status = err.response ? err.response.status : null;
  const codigo = err.response && err.response.data ? err.response.data.codigo : null;
  return status === 403 || codigo === 4030;
};

const shouldHandleError = (err, options = {}) => {
  if (options.skipErrorHandling) return false;
  if (options.skipPermissionDeniedErrorHandling && isPermissionDeniedError(err)) return false;
  return true;
};

// Se pasa un service o modulo. E.G.: "/moviles" "/moviles/2"
export const getData = (service, options = {}) => {
  return new Promise((resolve, reject) => {
    axios({
      method: 'GET',
      url: Config.get('apiUrlBase') + service,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Authorization-Token': localStorage.getItem('token'),
      },
    })
      .then((res) => resolve(res.data))
      .catch((err) => {
        if (shouldHandleError(err, options)) {
          handleError(err, options.intl || null);
        }
        reject(err);
      });
  });
};

// Se pasa un service o modulo como String. E.G.: "/moviles" "/moviles/2"
// Se suma un metodo como String. E.G.: "POST" "PUT"
export const sendData = (service, method, data) => {
  return new Promise((resolve, reject) => {
    axios({
      method: method,
      url: Config.get('apiUrlBase') + service,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Authorization-Token': localStorage.getItem('token'),
      },
      data: data,
    })
      .then((res) => resolve(res.data))
      .catch((err) => {
        handleError(err);
        reject(err);
      });
  });
};

export const dataBlob = (service, method, data) => {
  return new Promise((resolve, reject) => {
    axios({
      method: method,
      url: Config.get('apiUrlBase') + service,
      responseType: 'blob',
      headers: {
        'Content-Type': 'application/json',
        'Authorization-Token': localStorage.getItem('token'),
      },
      data: data,
    })
      .then((res) => {
        let name = res.headers['content-disposition'].split('=')[1]
        let data = {filename: name, data: res.data}
        return resolve(data)
      })
      .catch((err) => {
        handleError(err);
        reject(err);
      });
  });
};

export const sendDataBlob = (service, method, data) => {
  console.log(service, method, data);
  
  return new Promise((resolve, reject) => {
    axios({
      method: method,
      url: Config.get('apiUrlBase') + service,
      responseType: 'blob',
      headers: {
        'Content-Type': 'application/json',
        'Authorization-Token': localStorage.getItem('token'),
      },
      data: data,
    })
    .then((res) => resolve(res.data))
    .catch((err) => {
        handleError(err);
        reject(err);
      });
  });
};

// Se pasa un service o modulo como String. E.G.: "/moviles" "/moviles/2"
export const deleteData = (service) => {
  return new Promise((resolve, reject) => {
    axios({
      method: 'DELETE',
      url: Config.get('apiUrlBase') + service,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Authorization-Token': localStorage.getItem('token'),
      },
    })
      .then((res) => resolve(res.data))
      .catch((err) => (err.response.data.codigo === 4000 ? reject(err) : handleError(err)));
  });
};

let _showing403Modal = false;

// Maneja los errores con un modal de sweet-alert;
const getBackendErrorDetail = (detail) => {
  if (!detail) {
    return "";
  }

  let detalles = Array.isArray(detail) ? detail : [detail];

  return detalles.map(function(e) {
    return (backendStrings[e] && backendStrings[e].defaultMessage) ? backendStrings[e].defaultMessage : e;
  }).join('\n');
};

const handleError = (err, intl) => {
  return new Promise((resolve, reject) =>{
    let codigo = err.response && err.response.data ? err.response.data.codigo : null;
    let message = ""
    let detail = ""
    let status = err.response ? err.response.status : null;

    if(codigo === 4011 || codigo === 4010 || status === 401) {
      message = 'La sesión expiró.';
      detail = 'Por favor, ingrese nuevamente.';
    } else if(codigo === 4000) {
      message = err.response.data.mensaje;
      detail = getBackendErrorDetail(err.response.data.detalle);
    } else if(codigo === 4030 || status === 403) {
      message = intl
        ? intl.formatMessage({ id: 'ajaxHandler.errors_403.error_no_tiene_permisos_para_realizar_esta_accion', defaultMessage: 'No tiene permisos para realizar esta acción.' })
        : 'No tiene permisos para realizar esta acción.';
      var responseDetalle = err.response && err.response.data && err.response.data.detalle ? err.response.data.detalle : null;
      if (responseDetalle && Array.isArray(responseDetalle) && responseDetalle.length > 0) {
        detail = responseDetalle.join(', ');
      } else {
        detail = intl
          ? intl.formatMessage({ id: 'ajaxHandler.errors_403.error_contacte_al_administrador', defaultMessage: 'Contacte al administrador.' })
          : 'Contacte al administrador.';
      }
    } else if(codigo >= 5000) {
      message = 'Error interno del sistema.';
      detail = 'Contacte al administrador.';
    } else if(status === 404) {
      message = 'Recurso no encontrado.';
      detail = 'El recurso solicitado no existe.';
    } else if(status === 400) {
      message = 'Error';
      if (err.response.data && err.response.data.detalle) {
        detail = getBackendErrorDetail(err.response.data.detalle);
      }
    } else if(!err.response) {
      message = 'Error de conexión.';
      detail = 'No se pudo comunicar con el servidor.';
    }
   
    if(codigo === 4011 || codigo === 4010 || status === 401) {
      swal({
        title: message,
        text: detail,
        icon: "error",
        buttons: {
          confirm: {
            text: 'Aceptar',
            value: true,
            visible: true,
            className: "btn btn-primary",
            closeModal: true
          }
        }
      }).then((isConfirmed) => {
        if (isConfirmed) {
          window.location.reload();
          resolve(message)
        }
      });
    }
    else{
      if (codigo === 4030 || status === 403) {
        if (_showing403Modal) {
          resolve('');
          return;
        }
        _showing403Modal = true;
        const reset403ModalFlag = function() {
          _showing403Modal = false;
        };
        const fallbackResetTimeout = setTimeout(reset403ModalFlag, MODAL_RESET_TIMEOUT_MS);
        Promise.resolve(swal.fire(message, detail, 'error'))
          .then(reset403ModalFlag)
          .catch(reset403ModalFlag)
          .finally(function() { clearTimeout(fallbackResetTimeout); });
        resolve(message);
      } else {
        swal.fire(message, detail, 'error');
        resolve(message);
      }
    }
  })

};

export const getDataNoErrorMessage = (service) => {
  return new Promise((resolve, reject) => {
    axios({
      method: 'GET',
      url: Config.get('apiUrlBase') + service,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Authorization-Token': localStorage.getItem('token'),
      },
    })
      .then((res) => resolve(res.data))
      .catch((err) => {
          reject(err);
      });
  });
};

export const sendDataMultilanguage = (service, method, data, intl) => {
  return new Promise((resolve, reject) => {
    axios({
      method: method,
      url: Config.get('apiUrlBase') + service,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Authorization-Token': localStorage.getItem('token'),
      },
      data: data,
    })
      .then((res) => resolve(res.data))
      .catch((err) => {
        handleErrorMultilanguage(err, intl);
        reject(err);
      });
  });
};

const handleErrorMultilanguage = (err, intl) => {
  return new Promise((resolve, reject) =>{
    let codigo = err.response.data.codigo
    let message = ""
    let detail = ""
    
    if(codigo === 4011 || codigo === 4010 || err.response.status === 401) {
      message = 'La sesión expiró.';
      detail = 'Por favor, ingrese nuevamente.';
    } else if(codigo === 4000) {
      message = err.response.data.mensaje;
      detail = getBackendErrorDetail(err.response.data.detalle);
    } else if(codigo === 4030) {
      message = 'No tiene permisos para realizar esta acción.';
      detail = 'Contacte al administrador.';
    } else if(codigo >= 5000) {
      message = 'Error interno del sistema.';
      detail = 'Contacte al administrador.';
    }
  
    if(codigo === 4011 || codigo === 4010 || err.response.status === 401) {
      swal({
        title: message,
        text: detail,
        icon: "error",
        buttons: {
          confirm: {
            text: 'Aceptar',
            value: true,
            visible: true,
            className: "btn btn-primary",
            closeModal: true
          }
        }
      }).then((isConfirmed) => {
        if (isConfirmed) {
          window.location.reload();
          resolve(message)
        }
      });
    }
    else{
      swal.fire(message, detail || intl.formatMessage({ ...backendStrings['errors.default'] }), 'error');
      resolve(message)
    }
  })

};

/**
 * Obtiene datos para prefetch de filtros.
 * - Éxito: devuelve el payload.
 * - 403/4030: devuelve null sin modal.
 * - Otros errores: muestra notificación vía getData y devuelve null.
 *
 * `intl` es opcional. Si no se provee, getData conserva el comportamiento
 * actual de fallback a los mensajes por defecto (hard-coded en español) para
 * errores no relacionados con permisos.
 */
export const getDataOrNull = (service, intl = null) => {
  return getData(service, { intl }).catch(() => null);
};

export const formatTiempoEnTaller = (segundos) => {
  if (segundos === null || segundos === undefined) return '—';
  var dias = Math.floor(segundos / 86400);
  var horas = Math.floor((segundos % 86400) / 3600);
  var minutos = Math.floor((segundos % 3600) / 60);
  var partes = [];
  if (dias > 0) partes.push(dias + (dias === 1 ? ' día' : ' días'));
  if (horas > 0) partes.push(horas + 'h');
  if (minutos > 0 || partes.length === 0) partes.push(minutos + 'm');
  return partes.join(' ');
};
